export default __webpack_public_path__ + "static/media/video-placeholder-3.501bd3b1.png";